module.exports = __webpack_public_path__ + "img/rain.83110531.svg";